import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ShareService } from './../services/services';
import {Roomlisting,RoomlistingService } from './roomlisting.services';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { AlertService} from './../services/alert.service';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  address: string;
  email: string;
  contactno: string;
  
  
}
let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let hotemodel;



if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    
    
    if(jsonObject.hotel)
    {
	    hotemodel=true;
    }
    else
    {
	    hotemodel=false;
    }
}
console.log("hoteldata"+hotemodel);
let componentdata;
if(hotemodel)
{
   
	//template: require('./contacthome.component.html')
	componentdata={selector: 'hotelbooking',templateUrl: './pg/hotel/roombooking.component.html'}
	//templateUrl: './pg/hotel/roombooking.component.html',
}
else
{
    
   componentdata={selector: 'hotelbooking',template: '<div></div>'}

   
}
@Component(componentdata)


export class BookingHomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
	public apiData;
	public params;
	public siteinfo;
    public metadescription;
    BookingForm: FormGroup;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private alertService: AlertService,
	    public fb: FormBuilder,
	    private _pageService: RoomlistingService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  address:'',
                  email:'',
                  contactno:''
                 
				  	}
				  	
		   		  this.BookingForm = fb.group({
      'checkin': [
        '', // default value
        Validators.compose([Validators.required])
      ],
      'checkout': [
        '',
        Validators.compose([Validators.required])
      ],
      'adult': [
        '',
        Validators.compose([Validators.required])
      ],
      'child': [
        '',
        Validators.compose([Validators.required])
      ]
    });
				  	
		 
	    }
	    

	ngOnInit() {
	
	    // this.pagedata.email=this.shareService.getemail();
	     
	     ///alert(this.shareService.getemail());
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	   
	  		
	
		
	}

    ngOnDestroy() {
       //this._sub.unsubscribe();
    }
    BookingValidate(): boolean {

  if (this.BookingForm.valid) {
    return true;
  }
  let errorMsg = '';
  

  let field_checkin =document.querySelector('input[id="checkin"]')['value'];  
  if (!field_checkin) {
    if (field_checkin.errors['required']) {
      errorMsg = 'Provide Select Check In Date.<br />';
    }
  }

  let field_checkout = document.querySelector('input[id="checkout"]')['value']; ;
  if (!field_checkout) {
    if (field_checkout.errors['required']) {
      errorMsg = errorMsg+'Provide Select Check Out Date.<br />';
    }
  }
  
  
 if(errorMsg!="")
 {
    //alert(errorMsg);
    this.alertService.error(errorMsg);
    
  return false;
  }
  else
  {
    return true;
  }
}
    
    
    doBooking(event) {
       
      // let checkin = this.BookingForm.controls['checkin'].value;       
       //console.log("Testing1->"+checkin);
          
       
     if (this.BookingValidate()) {
    
            let checkin = document.querySelector('input[id="checkin"]')['value'];
			let checkout = document.querySelector('input[id="checkout"]')['value'];
			     			
            this.params = {
                 
                  checkin: checkin,
                  checkout: checkout,
                  adult: "2",
                  child:"0"
                  
                };
                this.shareService.setbooking(this.params);
                this._pageService.deletelisting();
                this._router.navigate(['./h/booking']);
                
                
             // this._router.navigate(['./h/booking']);
   // );
               
               
               
              
    //};
  }
     }
  
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/hotel/bookinghome.component.ts